import { useMemo } from "react";
import { ESubscriptionCancellationReason } from "@devowl-wp/api-real-commerce";
import { __ } from "../../../utils/i18n.js";
// `isReadOnly` marks system-set reasons (e.g. `PaymentFailed`) that consumers
// must filter out of any user-facing picker — the user must not be able to
// claim a reason that only the system can assign.
function useAccountV2SubscriptionCancellationReason() {
    return useMemo(()=>{
        const result = {};
        Object.keys(ESubscriptionCancellationReason).forEach((key)=>{
            let isReadOnly = false;
            const value = ESubscriptionCancellationReason[key];
            let localized = key;
            switch(value){
                case ESubscriptionCancellationReason.ProductIssue:
                    localized = __("(Technical) problem with the product");
                    break;
                case ESubscriptionCancellationReason.BetterAlternativeFound:
                    localized = __("Better alternative found");
                    break;
                case ESubscriptionCancellationReason.TooExpensive:
                    localized = __("Too expensive");
                    break;
                case ESubscriptionCancellationReason.NoNeedAnymore:
                    localized = __("No need for it anymore");
                    break;
                case ESubscriptionCancellationReason.PaymentFailed:
                    localized = __("Payment failed");
                    isReadOnly = true;
                    break;
                default:
                    localized = __("I'd rather not say");
                    break;
            }
            result[value] = {
                localized,
                key,
                value,
                isReadOnly
            };
        });
        return result;
    }, []);
}
export { useAccountV2SubscriptionCancellationReason };
